<h2 class="mb-24">How is the fixed tax applied?</h2>

<div style="width: 100%">
  <mat-radio-group [(ngModel)]="tax.calculation_type">
    <div fxLayout fxLayoutGap="4px" fxLayoutAlign="start center" *ngFor="let rate of definedFixedRates; let i = index">
      <mat-radio-button class="selection-box" [value]="rate.key">
        <span fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
          <span fxFlex>{{ rate.label }}</span>
        </span>
      </mat-radio-button>
    </div>
  </mat-radio-group>
</div>

<div style="margin-top: 32px" fxLayout fxLayoutGap="24px" fxLayoutAlign="end center">
  <sbnb-button
    data-intercom-target="direct-add-tax-calculation-back"
    label="Back"
    type="secondary"
    (clicked)="back()"
    routerLink=""></sbnb-button>

  <sbnb-button
    data-intercom-target="direct-add-tax-calculation-save"
    label="Continue"
    [disabled]="!tax.calculation_type"
    (clicked)="progress()"></sbnb-button>
</div>
